import {
    GET_CURRENT_USER_PROFILE_REQUEST,
    GET_CURRENT_USER_PROFILE_SUCCESS,
    GET_CURRENT_USER_PROFILE_FAILURE,
    UPDATE_CURRENT_USER_PROFILE_REQUEST,
    UPDATE_CURRENT_USER_PROFILE_SUCCESS,
    UPDATE_CURRENT_USER_PROFILE_FAILURE,
    UPDATE_SCHOOL_REQUEST,
    UPDATE_SCHOOL_SUCCESS,
    UPDATE_SCHOOL_FAILURE,
} from './types';

const initialState = {
    profile: null,
    profileLoading: false,
    profileErrors: null,

    profileUpdated: false,
    updateProfileLoading: false,
    updateProfileErrors: {},

    schoolUpdated: false,
    updateSchoolLoading: false,
    updateSchoolErrors: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CURRENT_USER_PROFILE_REQUEST:
            return {
                ...state,
                profileLoading: true,
                profileErrors: null,
            };
        case GET_CURRENT_USER_PROFILE_SUCCESS:
            return {
                ...state,
                profile: action.payload,
                profileLoading: false,
                profileErrors: null,
            };
        case GET_CURRENT_USER_PROFILE_FAILURE:
            return {
                ...state,
                profile: null,
                profileLoading: false,
                profileErrors: action.payload,
            };
        case UPDATE_CURRENT_USER_PROFILE_REQUEST:
            return {
                ...state,
                profileUpdated: false,
                updateProfileLoading: true,
                updateProfileErrors: {},
            };
        case UPDATE_CURRENT_USER_PROFILE_SUCCESS:
            return {
                ...state,
                profileUpdated: true,
                updateProfileLoading: false,
                updateProfileErrors: {},
            };
        case UPDATE_CURRENT_USER_PROFILE_FAILURE:
            return {
                ...state,
                profileUpdated: false,
                updateProfileLoading: false,
                updateProfileErrors: action.payload,
            };
        case UPDATE_SCHOOL_REQUEST:
            return {
                ...state,
                schoolUpdated: false,
                updateSchoolLoading: true,
                updateSchoolErrors: {},
            };
        case UPDATE_SCHOOL_SUCCESS:
            return {
                ...state,
                schoolUpdated: true,
                updateSchoolLoading: false,
                updateSchoolErrors: {},
            };
        case UPDATE_SCHOOL_FAILURE:
            return {
                ...state,
                schoolUpdated: false,
                updateSchoolLoading: false,
                updateSchoolErrors: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/features/Dashboard/reducers.js